import ApiClient from './ApiClient';

class PoolClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}/pools` : '/pools');
  }

  async getPools() {
    try {
      const data = await this.get('');
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch pools: ${error.message}`);
    }
  }
}

export default PoolClient;
